module.exports = __webpack_public_path__ + "img/header-engagementRingsLabGrownDiamonds@2x.f2dc2bc.jpg";